'use strict';

define('lib/helpers/monetize',['Handlebars', 'lib/readable-monetize'], function (Handlebars, readableMonetize) {
  Handlebars.registerHelper('monetize', function (text) {
    return new Handlebars.SafeString(readableMonetize(text));
  });
});

